import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import NavigationUser from '../../Layouts/Navigation/NavigationUser';
import { Container, Typography, Box, Paper, Table, TableBody, TableCell, 
    TableContainer, TableHead, TableRow, TablePagination, Button, Dialog, 
    DialogContent, DialogTitle, Snackbar, Alert, IconButton, 
    TableFooter} from '@mui/material';
import { format } from 'date-fns';
import PostAddIcon from '@mui/icons-material/PostAdd';
import { BASE_URL } from '../../utils/constants';
import useAutoDismissSnack from '../../Hooks/AutoDismissSnack';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { QRCodeCanvas } from 'qrcode.react';
import { TextField, DialogActions} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import dayjs from 'dayjs';
import ShareIcon from '@mui/icons-material/Share';
import DownloadIcon from '@mui/icons-material/Download';
import html2canvas from 'html2canvas';


function VisitsUsrReport() {  

    const [visitas, setVisitas] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [openDialog, setOpenDialog] = useState(false);
    const [visitInfo, setVisitInfo] = useState(null);
    const [InquilinoId, setInquilinoId] = useState(null);

    const [rescheduleOpen, setRescheduleOpen] = useState(false);
    const [newDate, setNewDate] = useState(dayjs());

    //Snack notifications
    const [openSnack, setOpenSnack] = React.useState(false);
    const [snackStatus, setSnackStatus] = useState("");
    const [snackMessage, setSnackMessage] = useState("");
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const qrBoxRef = useRef(); // Crea una referencia para el Box que contiene el código QR

    const getRowColor = (flag) => {
        switch (flag) {
            case 2:
                return '#ffdddd'; // Rojo para flag 2
            case 1:
                return '#ddffdd'; // Verde para flag 1
            case 0:
                return '#fff4ec'; // Naranja para flag 0
            default:
                return 'inherit';
        }
    };

    const handleClickSnack = () => {
        setOpenSnack(true);
    };

    const handleCloseSnack = () => {
        setOpenSnack(false);
    };
    useAutoDismissSnack(openSnack, setOpenSnack);
    
    const handleClose = () => {
        setOpenDialog(false);
    };

    const handleRescheduleVisit = () => {
        setRescheduleOpen(true);
    };
    
    const handleSaveReschedule = () => {
        const visitId = visitInfo.id_visita;
        const formattedDate = newDate.format('YYYY-MM-DD HH:mm:ss'); // Formatear la fecha
    
        axios.put(`${BASE_URL}/updateVisitDate`, { id_visita: visitId, fecha: formattedDate })
            .then((response) => {
                if (response.status === 200) {
                    setSnackStatus("success");
                    setSnackMessage("Visita reagendada con éxito!");
                    setRescheduleOpen(false);
                    getVisitasByIdInquilino(InquilinoId); // Actualizar la información de la visita
                    //necesito cerrar el dialogo
                    setOpenDialog(false);
                } else {
                    setSnackStatus("error");
                    setSnackMessage("Error al reagendar visita.");
                }
                handleClickSnack();
            })
            .catch((error) => {
                handleClickSnack();
            });
    };
    
    const handleDateTimeChange = (newDateTime) => {
        setNewDate(newDateTime);
    };

    const formatDate = (dateString) => {
        return format(new Date(dateString), 'yyyy-MM-dd hh:mm:ss a');
    };

    const getVisitasByIdInquilino = (id_usuario) => {
        axios.get(`${BASE_URL}/getVisitsByUser/${id_usuario}`)
        .then((response) => {
            const sortedVisitas = response.data.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
            setVisitas(sortedVisitas);
            //console.log(sortedVisitas);
        })
        .catch((error) => {
            console.log(error);
        });
    };
  
    const handleInfoVisit = (visita) => {
        setVisitInfo(visita); // Actualiza la información de la visita
        setOpenDialog(true); // Abre el diálogo
    };

    const handleDownloadQR = () => {
        const qrBox = qrBoxRef.current; // Obtiene el elemento del Box

        // Crea una captura de pantalla del Box
        html2canvas(qrBox).then((canvas) => {
            const imgData = canvas.toDataURL('image/png'); // Convierte el canvas en una imagen PNG
            const link = document.createElement('a');
            link.href = imgData;
            link.download = `${visitInfo.token}.png`;
            link.click();
        });
    };

    const handleShareQR = () => {
        const qrBox = qrBoxRef.current;

        // Crea una captura de pantalla del Box con mayor resolución
        html2canvas(qrBox, { scale: 2 }).then((canvas) => {
            canvas.toBlob((blob) => {
                const file = new File([blob], `${visitInfo.token}.png`, { type: 'image/png' });
                if (navigator.share) {
                    navigator.share({
                        title: 'QR Code',
                        text: 'Aquí está el código QR para la visita.',
                        files: [file],
                    }).catch((error) => console.log('Error sharing', error));
                } else {
                    console.log('Web Share API not supported.');
                }
            }, 'image/png', 1);
        });
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const decodedToken = jwtDecode(token);
            const id_usuario = decodedToken.id_usuario;
            setInquilinoId(id_usuario);
            getVisitasByIdInquilino(id_usuario);
        } else {
            console.log('No hay token');
        }
    }, []);

    return (
        <>
            <NavigationUser/>
            
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 lg:p-8">
                <div className="max-w-7xl mx-auto">
                    {/* Header */}
                    <div className="mb-8">
                        <h1 className="text-3xl font-bold text-gray-800 mb-2">Reporte de Visitas</h1>
                        <p className="text-gray-600">Gestiona y revisa todas tus visitas programadas</p>
                    </div>

                    {/* Estadísticas rápidas */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                        <div className="bg-white rounded-xl shadow-md p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm text-gray-600 mb-1">Total</p>
                                    <p className="text-3xl font-bold text-gray-800">{visitas.length}</p>
                                </div>
                                <div className="p-3 bg-blue-100 rounded-lg">
                                    <span className="text-2xl">📊</span>
                                </div>
                            </div>
                        </div>
                        <div className="bg-white rounded-xl shadow-md p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm text-gray-600 mb-1">Pendientes</p>
                                    <p className="text-3xl font-bold text-amber-600">
                                        {visitas.filter(v => v.flag_ingreso === 0).length}
                                    </p>
                                </div>
                                <div className="p-3 bg-amber-100 rounded-lg">
                                    <span className="text-2xl">⏳</span>
                                </div>
                            </div>
                        </div>
                        <div className="bg-white rounded-xl shadow-md p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm text-gray-600 mb-1">Completadas</p>
                                    <p className="text-3xl font-bold text-green-600">
                                        {visitas.filter(v => v.flag_ingreso === 1).length}
                                    </p>
                                </div>
                                <div className="p-3 bg-green-100 rounded-lg">
                                    <span className="text-2xl">✅</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Snackbar open={openSnack} autoHideDuration={5000} onClose={handleCloseSnack}>
                        <Alert 
                        onClose={handleCloseSnack} 
                        severity={snackStatus} 
                        sx={{ width: '100%' }}>
                        {snackMessage}
                        </Alert>
                    </Snackbar>

                    {/* Tabla de Visitas Centrada */}
                    <div className="max-w-6xl mx-auto px-4">
                        {visitas.length === 0 ? (
                            <div className="bg-white rounded-xl shadow-md p-12 text-center">
                                <span className="text-6xl mb-4 block">📋</span>
                                <p className="text-gray-600 text-lg">No hay visitas disponibles.</p>
                                <p className="text-gray-400 mt-2">Programa tu primera visita desde el módulo de visitas</p>
                            </div>
                        ) : (
                            <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
                                <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
                                    <Table sx={{ minWidth: 650 }} stickyHeader>
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: '#10b981' }}>
                                                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem', color: '#ffffff', borderBottom: '2px solid #059669' }}>Nombre</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem', color: '#ffffff', borderBottom: '2px solid #059669' }}>Fecha</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem', color: '#ffffff', borderBottom: '2px solid #059669' }}>Estado</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem', color: '#ffffff', borderBottom: '2px solid #059669' }}>Información</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {visitas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((visita) => (
                                                <TableRow
                                                    key={visita.id_visita}
                                                    sx={{ 
                                                        backgroundColor: getRowColor(visita.flag_ingreso), 
                                                        '&:hover': { backgroundColor: '#d1fae5', transform: 'scale(1.005)' },
                                                        transition: 'all 0.2s',
                                                        '&:last-child td, &:last-child th': { border: 0 } 
                                                    }}
                                                >
                                                    <TableCell sx={{ fontSize: '0.875rem', fontWeight: 500, padding: '16px' }}>
                                                        {visita.nombre} {visita.apellido}
                                                    </TableCell>
                                                    <TableCell sx={{ fontSize: '0.875rem', padding: '16px' }}>
                                                        {visita.flag_ingreso === 1 
                                                            ? formatDate(visita.created_at) 
                                                            : formatDate(visita.fecha)}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '16px' }}>
                                                        {visita.flag_ingreso === 1 ? (
                                                            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800 shadow-sm">
                                                                ✅ Completada
                                                            </span>
                                                        ) : visita.flag_ingreso === 2 ? (
                                                            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800 shadow-sm">
                                                                ❌ Vencida
                                                            </span>
                                                        ) : (
                                                            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-amber-100 text-amber-800 shadow-sm">
                                                                ⏳ Pendiente
                                                            </span>
                                                        )}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '16px' }}>
                                                        <Button 
                                                            variant="outlined" 
                                                            size="small"
                                                            onClick={() => handleInfoVisit(visita)}
                                                            sx={{
                                                                textTransform: 'none',
                                                                borderRadius: '8px',
                                                                borderColor: '#10b981',
                                                                color: '#10b981',
                                                                fontWeight: 600,
                                                                '&:hover': {
                                                                    backgroundColor: '#d1fae5',
                                                                    borderColor: '#059669',
                                                                    transform: 'translateY(-2px)',
                                                                    boxShadow: '0 4px 6px rgba(16, 185, 129, 0.25)'
                                                                },
                                                                transition: 'all 0.2s'
                                                            }}
                                                        >
                                                            <PostAddIcon sx={{ fontSize: 18, mr: 0.5 }} />
                                                            Ver
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={visitas.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={(event, newPage) => {
                                        setPage(newPage);
                                    }}
                                    onRowsPerPageChange={(event) => {
                                        setRowsPerPage(parseInt(event.target.value, 10));
                                        setPage(0);
                                    }}
                                    sx={{
                                        borderTop: '2px solid #e2e8f0',
                                        backgroundColor: '#f9fafb'
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* DIALOGO PARA MOSTRAR INFORMACION DE VISITA */}
            <Dialog
                fullScreen={fullScreen}
                fullWidth
                maxWidth="md"
                sx={{ 
                    width: { xs: '90%', md: '80%' }, 
                    mx: 'auto',
                    '& .MuiDialog-paper': {
                        borderRadius: '16px',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                    }
                }}
                open={openDialog}
                onClose={handleClose}
            >
                <DialogTitle sx={{ 
                    textAlign: 'center',
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    color: 'white',
                    paddingY: 3,
                    borderRadius: '16px 16px 0 0'
                }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                        📋 Detalles de la Visita
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.95 }}>
                        Estado: {visitInfo ? (
                            <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                                visitInfo.flag_ingreso === 1 ? 'bg-green-100 text-green-800' :
                                visitInfo.flag_ingreso === 2 ? 'bg-red-100 text-red-800' :
                                'bg-amber-100 text-amber-800'
                            }`}>
                                {visitInfo.flag_ingreso === 1 ? '✅ Completada' :
                                 visitInfo.flag_ingreso === 2 ? '❌ Vencida' :
                                 '⏳ Pendiente'}
                            </span>
                        ) : 'Cargando...'}
                    </Typography>
                    {visitInfo && visitInfo.flag_ingreso === 1 && (
                        <Typography variant="caption" sx={{ display: 'block', mt: 1, opacity: 0.9 }}>
                            Fecha y hora de ingreso: {formatDate(visitInfo.created_at)}
                        </Typography>
                    )}
                </DialogTitle>
                    <DialogContent sx={{ p: 3, backgroundColor: '#f9fafb' }}>
                        {visitInfo ? (
                            <div className="space-y-4">
                                {/* Información de la visita */}
                                <div className="bg-white rounded-lg shadow-md overflow-hidden border border-green-100">
                                    <div className="bg-gradient-to-r from-green-600 to-green-500 px-4 py-3">
                                        <h3 className="text-white font-bold text-sm">📋 Información de la Visita</h3>
                                    </div>
                                    <div className="divide-y divide-gray-100">
                                        <div className="px-4 py-3 grid grid-cols-2 gap-x-4">
                                            <span className="text-sm font-semibold text-gray-600">Nombre:</span>
                                            <span className="text-sm text-gray-800">{visitInfo.nombre} {visitInfo.apellido}</span>
                                        </div>
                                        <div className="px-4 py-3 grid grid-cols-2 gap-x-4">
                                            <span className="text-sm font-semibold text-gray-600">Fecha:</span>
                                            <span className="text-sm text-gray-800">
                                                {visitInfo.flag_ingreso === 1 ? formatDate(visitInfo.created_at) : formatDate(visitInfo.fecha)}
                                            </span>
                                        </div>
                                        <div className="px-4 py-3 grid grid-cols-2 gap-x-4">
                                            <span className="text-sm font-semibold text-gray-600">Estado:</span>
                                            <span className="text-sm">
                                                {visitInfo.flag_ingreso === 1 ? (
                                                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800">
                                                        ✅ Completada
                                                    </span>
                                                ) : visitInfo.flag_ingreso === 2 ? (
                                                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800">
                                                        ❌ Vencida
                                                    </span>
                                                ) : (
                                                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-amber-100 text-amber-800">
                                                        ⏳ Pendiente
                                                    </span>
                                                )}
                                            </span>
                                        </div>
                                        <div className="px-4 py-3 grid grid-cols-2 gap-x-4">
                                            <span className="text-sm font-semibold text-gray-600">Observaciones:</span>
                                            <span className="text-sm text-gray-800">{visitInfo.observacion || 'Sin observaciones'}</span>
                                        </div>
                                        {visitInfo.tipo_vehiculo !== 'NO' && (
                                            <>
                                                <div className="px-4 py-3 grid grid-cols-2 gap-x-4">
                                                    <span className="text-sm font-semibold text-gray-600">Tipo de Vehículo:</span>
                                                    <span className="text-sm text-gray-800">{visitInfo.tipo_vehiculo}</span>
                                                </div>
                                                <div className="px-4 py-3 grid grid-cols-2 gap-x-4">
                                                    <span className="text-sm font-semibold text-gray-600">Placa:</span>
                                                    <span className="text-sm text-gray-800 font-bold">{visitInfo.placa}</span>
                                                </div>
                                            </>
                                        )}
                                        {visitInfo.num_acompanantes !== 0 && (
                                            <div className="px-4 py-3 grid grid-cols-2 gap-x-4">
                                                <span className="text-sm font-semibold text-gray-600">Acompañantes:</span>
                                                <span className="text-sm text-gray-800 font-bold">{visitInfo.num_acompanantes}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Código QR para visitas pendientes */}
                                {visitInfo.flag_ingreso === 0 && (
                                    <div className="bg-white rounded-lg shadow-md overflow-hidden border border-green-100">
                                        <div className="bg-gradient-to-r from-green-600 to-green-500 px-4 py-3">
                                            <h3 className="text-white font-bold text-sm">🔐 Código de Acceso</h3>
                                        </div>
                                        <div className="p-6 text-center bg-gray-50">
                                            <Box sx={{ textAlign: 'center', marginTop: '10px' }} ref={qrBoxRef}>
                                                <Typography gutterBottom sx={{ fontWeight: 600, color: '#374151' }}>
                                                    Escanea este código para ingresar
                                                </Typography> 
                                                <div className="my-4 flex justify-center">
                                                    <QRCodeCanvas value={visitInfo.token} size={256} />
                                                </div>
                                                <Typography gutterBottom sx={{ fontSize: '0.875rem', color: '#9ca3af' }}>
                                                    Este código es de un solo uso
                                                </Typography> 
                                            </Box>
                                            <Box sx={{ textAlign: 'center', marginTop: '20px', display: 'flex', justifyContent: 'center', gap: 2 }}>
                                                <button
                                                    onClick={handleDownloadQR}
                                                    className="px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 hover:shadow-lg transition-all duration-200 flex items-center gap-2"
                                                >
                                                    <DownloadIcon sx={{ fontSize: 18 }} />
                                                    Descargar
                                                </button>
                                                <button
                                                    onClick={handleShareQR}
                                                    className="px-4 py-2 bg-purple-600 text-white font-semibold rounded-lg shadow-md hover:bg-purple-700 hover:shadow-lg transition-all duration-200 flex items-center gap-2"
                                                >
                                                    <ShareIcon sx={{ fontSize: 18 }} />
                                                    Compartir
                                                </button>
                                            </Box>
                                        </div>
                                    </div>
                                )}

                                {/* Botón de reagendar para visitas vencidas */}
                                {visitInfo.flag_ingreso === 2 && (
                                    <div className="flex justify-center pt-2">
                                        <button
                                            onClick={handleRescheduleVisit}
                                            className="px-6 py-2.5 bg-gradient-to-r from-amber-600 to-amber-500 text-white font-semibold rounded-lg shadow-md hover:shadow-lg hover:from-amber-700 hover:to-amber-600 transition-all duration-200 transform hover:-translate-y-0.5"
                                        >
                                            🔄 Reagendar Visita
                                        </button>
                                    </div>
                                )}

                                {/* Botón cerrar */}
                                <div className="flex justify-center pt-2">
                                    <button
                                        onClick={handleClose}
                                        className="px-6 py-2.5 bg-gradient-to-r from-green-600 to-green-500 text-white font-semibold rounded-lg shadow-md hover:shadow-lg hover:from-green-700 hover:to-green-600 transition-all duration-200 transform hover:-translate-y-0.5"
                                    >
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="text-center py-8">
                                <Typography>Cargando...</Typography>
                            </div>
                        )}
                    </DialogContent>

                {/* Dialog para reagendar */}
                <Dialog open={rescheduleOpen} onClose={() => setRescheduleOpen(false)}>
                    <DialogTitle>Reagendar visita</DialogTitle>
                    <DialogContent>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <MobileDateTimePicker
                                label="Fecha y hora de visita"
                                value={newDate}
                                onChange={handleDateTimeChange}
                                minDateTime={dayjs()}
                                components={{
                                    textField: TextField
                                }}
                                textFieldProps={{
                                    required: true,
                                    margin: 'dense',
                                    variant: 'standard',
                                    fullWidth: true
                                }}
                            />
                        </LocalizationProvider>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setRescheduleOpen(false)} color="secondary">
                            Cancelar
                        </Button>
                        <Button onClick={handleSaveReschedule} color="primary">
                            Guardar
                        </Button>
                    </DialogActions>
                </Dialog>
            </Dialog>
        </>
    );
}

export default VisitsUsrReport;